import { calcInterests } from 'assets/js/methods'
import route from 'vue-router'
export const state = () => ({
    company_domain: 'unicopag.com.br',
    company_name: '',
    store: '',
    gateway: '',
    gatewayUpsell: '',
    gateways: [],
    couponQueue: [],
    gateways_retry: [],
    product: '',
    cart: '',
    checkout: '',
    orderbumps: '',
    testimonials: '',
    custom_form_checkouts: '',
    custom_form_options: '',
    bonus: '',
    customer: '',
    pixels: '',
    paymentData: '',
    paymentMethodSelected: null,
    coupon: '',
    automatic_coupons: [],
    shippings: [],
    shipping: {},
    setup: {
        installments: 12,
        forceFreeShipping: false,
        isDev: process.env.NODE_ENV == 'development' ? true : false,
    },
    eventsFire: {
        InitiateCheckout: false,
        Lead: false,
        CompleteRegistration: false,
        AddPaymentInfo: false,
        Purchase: false,
    },
    tracking: {
        src: '',
        utm_source: '',
        utm_medium: '',
        utm_campaign: '',
        utm_term: '',
        utm_content: '',
    },
    custom_checkout: '',
    payment_methods: {
        creditcard: true,
        pix: true,
        billet: false,
    },
    payment_method_pre_selected: null,
    formState: {
        clickSubmitButton: false,
        inputSubmit: false,
        firstStepValid: false,
        addressValid: false,
        formValid: false,
    },
    transactionData: {},
    mercadopagoInstallments: '',
    appMaxInstallments: '',
    tracker_init: false,
    klaviyoKey: '',
    device_id: null,
    datalayerModel: 'unicopag',
})

export const getters = {
    getCoupon: (state) => (couponId) => {
        return state.couponQueue.find(coupon => coupon.id === couponId);
    },
    getCouponQueue(state) {
        return state.couponQueue;
    },
    getStore: (state) => {
        return state.store
    },
    getCustomCheckout: (state) => {
        return state.custom_checkout
    },
    getTestimonials: (state) => {
        return state.testimonials
    },
    getCustomFormCheckouts: (state) => {
        return state.custom_form_checkouts
    },
    getCustomFormOptions: (state) => {
        return JSON.parse(state.custom_form_options)
    },
    getLogisticsShippings: (state) => {
        return state.shippings
    },
    getProduct: (state) => {
        return state.product
    },
    getGateway: (state) => {
        return state.gateway
    },
    getGatewayUpsell: (state) => {
        return state.gatewayUpsell
    },
    getGateways: (state) => {
        return state.gateways
    },
    getCoupon: (state) => {
        return state.coupon
    },
    getAutomaticCoupons: (state) => {
        return state.automatic_coupons
    },
    getCart: (state) => {
        return state.cart || JSON.parse(localStorage.getItem('cart'))
    },
    getCartOrderbumps: (state) => {
        let cartOrderbumps = state.cart.filter((u) => u.operation_type === 2)

        return cartOrderbumps
    },
    getCartWithoutOrderbumps: (state) => {
        let getCartWithoutOrderbumps = state.cart.filter(
            (u) => u.operation_type !== 2
        )

        return getCartWithoutOrderbumps
    },
    getPixels: (state) => {
        return state.pixels
    },
    getFormState: (state) => {
        return state.formState
    },
    isDev: (state) => {
        return state.setup['isDev'] ?? ''
    },
    firstStepValid: (state) => {
        return state.formState['firstStepValid'] ?? ''
    },
    getPaymentMethods: (state) => {
        return state.payment_methods
    },
    getPaymentMethodPreSelected: (state) => {
        return state.payment_method_pre_selected
    },
    getEventsState: (state) => {
        return state.eventsFire
    },
    getCustomer: (state) => {
        return state.customer
    },
    getOrderBumps: (state) => {
        return state.orderbumps
    },
    getBonus: (state) => {
        return state.bonus
    },
    getMercadoPagoInstallments: (state) => {
        return state.mercadopagoInstallments
    },
    getAppMaxInstallments: (state) => {
        return state.appMaxInstallments
    },
    getSumary: (state) => {
        let result = {},
            interest_amount = {},
            calc_installments = {},
            installments = 12,
            total_amount = 0,
            subtotal = 0

        let cart = state.cart || []

        if (cart) {
            let total_quantity = 0;
            cart.forEach((element) => {
                total_quantity += element.quantity
                total_amount += element.price * element.quantity
                subtotal += element.price * element.quantity
            })

            let discount_value = 0

            if (state.coupon && typeof state.coupon.discount !== 'undefined') {
                if (state.coupon?.rules?.includes('pay_for_two_get_three')) {
                    if (total_quantity >= 3) {
                        discount_value = cart.reduce((menor, item) => item.price < menor ? item.price : menor, cart[0].price);
                    }
                } else if (state.coupon?.rules?.includes('pay_for_one_get_three')) {
                    if (total_quantity >= 3) {
                        discount_value = cart.reduce((menor, item) => item.price < menor ? item.price : menor, cart[0].price) * 2
                    }
                } else if (state.coupon?.rules?.includes('take_a_free_product')) {
                    discount_value = cart.reduce((menor, item) => item.price < menor ? item.price : menor, cart[0].price);
                } else if (state.coupon.discount_type === 'percent') {
                    discount_value = parseInt(
                        (parseInt(state.coupon.discount) / 100) *
                        parseInt(total_amount)
                    )
                } else if (state.coupon.discount_type === 'monetary') {
                    discount_value = parseInt(state.coupon.discount)
                }
            }
            let discount_value_coupon = discount_value

            let discount_value_new = 0

            if (
                state.paymentMethodSelected === 1 &&
                state.store.discount_creditcard > 0
            ) {
                discount_value_new = parseInt(
                    (parseInt(state.store.discount_creditcard) / 100) *
                    parseInt(total_amount)
                )
            } else if (
                state.paymentMethodSelected === 2 &&
                state.store.discount_billet > 0
            ) {
                discount_value_new = parseInt(
                    (parseInt(state.store.discount_billet) / 100) *
                    parseInt(total_amount)
                )
            } else if (
                state.paymentMethodSelected === 3 &&
                state.store.discount_pix > 0
            ) {
                discount_value_new = parseInt(
                    (parseInt(state.store.discount_pix) / 100) *
                    parseInt(total_amount)
                )
            }

            if (state.store.discount_sum_with_coupons === 0) {
                if (discount_value_new > discount_value) {
                    discount_value = 0
                } else {
                    discount_value_new = 0
                }
            }

            discount_value = discount_value + discount_value_new

            result['total_amount'] = parseInt(total_amount) - discount_value

            const exists_shipping_paid = state.shippings.filter((s) => s.price > 0).length > 0

            console.log('exists_shipping_paid:', exists_shipping_paid);

            let shipping = 0

            if (state.shipping && state.shipping.price > 0) {
                shipping = parseInt(state.shipping.price)
            }

            if (
                state?.custom_checkout &&
                state.custom_checkout.states &&
                state.custom_checkout.amount_min_free_shipping &&
                state.custom_checkout.amount_min_free_shipping !== null &&
                state.custom_checkout.amount_min_free_shipping !== ''
            ) {
                const dataLead = JSON.parse(localStorage.getItem('customer')) || {};
                const customCheckout = state.custom_checkout.states
                    ? JSON.parse(state.custom_checkout.states)
                    : [];
                const customerState = dataLead.state || '';
                const forceFreeShipping = customCheckout.includes(customerState);

                if (result.total_amount >= state.custom_checkout.amount_min_free_shipping) {
                    const isFreeShippingRestricted =
                        state.custom_checkout.free_shipping_custom_by_state === 0 ||
                        !forceFreeShipping;

                    if (isFreeShippingRestricted) {
                        shipping = 0;
                    }
                }
            }

            if (state.custom_checkout?.payment_method_pre_selected) {
                state.payment_method_pre_selected = state.custom_checkout?.payment_method_pre_selected
            }

            result.total_amount = result.total_amount + shipping

            let installments = state['setup']['installments']

            if (
                typeof state.gateway !== 'undefined' && typeof state.gateway.gateway_platform !== 'undefined' && state.gateway.gateway_platform === 'mercadopago' && state.paymentMethodSelected === 1
            ) {
                console.log('Enviar os dados de parcelamento do MercadoPago' + state.gateway.gateway_platform)

                if (state.mercadopagoInstallments !== '') {
                    var indice = 0

                    state.mercadopagoInstallments.forEach((v, k) => {
                        indice++
                        calc_installments[indice] = {
                            amount_input: result.total_amount,
                            // tax_interest: number,
                            amount_tax: v.installment_rate * 100,
                            amount_final: v.total_amount * 100,
                            amount_installment: v.installment_amount * 100,
                        }
                    })
                }
            } else if (typeof state.gateway !== 'undefined' && typeof state.gateway.gateway_platform !== 'undefined' && state.gateway.gateway_platform === 'appmax' && state.paymentMethodSelected === 1) {
                if (state.appMaxInstallments !== '') {
                    var indice = 0

                    var arrayappMaxInstallments = Object.keys(
                        state.appMaxInstallments
                    ).map((i) =>
                        JSON.parse(state.appMaxInstallments[Number(i)])
                    )

                    arrayappMaxInstallments.forEach((v, k) => {
                        indice++

                        calc_installments[indice] = {
                            amount_input: result.total_amount,
                            amount_final: v * 100,
                            amount_installment: (v * 100) / indice,
                        }
                    })
                }
            } else {

                var max_installments = 12;

                if (typeof state.gateway !== 'undefined' && state.gateway !== null && typeof state.gateway.recipient !== null) {
                    if (state.gateway.recipient && state.gateway.recipient.gateway === 'barte') {
                        var max_installments = 21;
                    }
                }

                const custom_interest = state.gateway ? state.gateway.custom_interest : 0;
                const free_installments = state.gateway ? state.gateway.free_installments : 0;
                let interest_amount = calcInterests(
                    result['total_amount'],
                    custom_interest,
                    0,
                    installments,
                    free_installments,
                )

                for (var a = 1; a <= max_installments; a++) {
                    calc_installments[a] = calcInterests(
                        result.total_amount,
                        custom_interest ?? 0,
                        a,
                        free_installments
                    )
                }
            }

            result['total_amount_installmented'] =
                interest_amount['amount_final'] ?? 0
            result['amount_installment'] =
                interest_amount['amount_installment'] ?? 0
            result['amount_discount'] = discount_value
            result['amount_discount_coupon'] = discount_value_coupon
            result['installments_data'] = calc_installments ?? []
            result['installments'] = installments ?? 12
            result['free_installments'] = state.gateway ? state.gateway.free_installments : 1
            result['shipping'] = shipping
            result['exists_shipping_paid'] = exists_shipping_paid
            result['subtotal'] = subtotal
        }

        return result
    },
    getDomain: (state) => {
        return state.company_domain;
    },
    getCompanyName: (state) => {
        return state.company_name;
    },
    getSetup: (state) => {
        return state.setup
    },
    getPlugins: (state) => {
        return state.plugins
    },
    getPaymentMethodSelected: (state) => {
        return state.paymentMethodSelected
    },
    getTracking: (state) => {
        return state.tracking
    },
    getPaymentData: (state) => {
        return state.paymentData
    },
    getInstallments: (state) => {
        return state.setup['installments']
    },
    getTransactionData: (state) => {
        return state.transactionData
    },
    getDatalayerModel: (state) => {
        return state.datalayerModel
    },
    getShipping: (state) => {
        return state.shipping
    },
    getTrackerInit: (state) => {
        return state.tracker_init
    },
    getKlaviyoKey: (state) => {
        return state.klaviyoKey
    },
    getDeviceId: (state) => {
        return state.device_id
    },
}

export const mutations = {
    setCouponData(state, coupon) {
        state.coupon = coupon;
    },
    setCouponQueue(state, couponQueue) {
        state.couponQueue = couponQueue;
    },
    setForceFreeShipping(state, payload) {
        state.setup.forceFreeShipping = payload
    },
    setTrackerInit(state, payload) {
        state.tracker_init = payload
    },
    setStore(state, payload) {
        state.store = payload
    },
    setCustomCheckout(state, payload) {
        state.custom_checkout = payload
    },
    setCustomFormOptions(state, payload) {
        state.custom_form_options = JSON.stringify(payload)
    },
    setTestimonials(state, payload) {
        state.testimonials = payload
    },
    setCustomFormCheckouts(state, payload) {
        state.custom_form_checkouts = payload
    },
    setLogisticsShippings(state, payload) {
        state.shippings = payload
    },
    setShippingSelected(state, payload) {
        state.shipping = payload
    },
    setProduct(state, payload) {
        state.product = payload
    },
    setCoupon(state, payload) {
        state.coupon = payload
        if (payload) {
            if (process.client) {
                if (typeof payload.rules == 'string') {
                    payload.rules = JSON.parse(payload.rules)
                }
                if (typeof payload.products == 'string') {
                    payload.products = JSON.parse(payload.products)
                }
                sessionStorage.setItem('coupon', JSON.stringify(payload))
            }
        }
    },
    setAutomaticCoupons(state, payload) {
        state.automatic_coupons = payload
        if (payload) {
            if (process.client) {
                sessionStorage.setItem('automatic_coupons', JSON.stringify(payload))
            }
        }
    },
    setGateway(state, payload) {
        state.gateway = payload.find((u) => u.payment_method === 'all')
        state.gateways = payload
    },

    setGatewayUpsell(state, payload) {
        state.gatewayUpsell = payload
    },
    setGatewayToRetry(state, payload) {
        state.gateway = payload
    },
    setGatewaysRetry(state, payload) {
        state.gateways_retry = payload
    },
    setCartItem(state, payload) {
        let cartStorage = localStorage.getItem('cart') || JSON.stringify([])

        if (cartStorage) {
            cartStorage = JSON.parse(cartStorage)
        }

        if (cartStorage) {
            let checkCartExit = false

            // !TODO: Don't items duplicated from cart when store id Brota Company 
            if (![1550, 1140].includes(cartStorage[0]?.store_id)) {
                checkCartExit = cartStorage.find(
                    (u) => u.cartvar === payload.cartvar
                )
            }

            if (!checkCartExit) {
                cartStorage.push(payload)
                state.cart = cartStorage

                if (process.client) {
                    localStorage.setItem('cart', JSON.stringify(cartStorage))
                }
            } else {
                let objIndex = cartStorage.findIndex(
                    (item) => item.cartvar === payload.cartvar
                )

                cartStorage[objIndex] = payload
                state.cart = cartStorage
            }

        }
    },
    updateQuantity(state, payload) {
        let cartStorage = JSON.parse(localStorage.getItem('cart')) || [];

        if (!cartStorage || !Array.isArray(cartStorage)) {
            cartStorage = [];
        }

        const cartIndex = cartStorage.findIndex(item => item.cartvar === payload.item.cartvar);
        if (cartIndex !== -1) {
            const cartItem = cartStorage[cartIndex];

            if (payload.operation === 'plus') {
                cartItem.quantity++;
            } else if (payload.operation === 'less' && cartItem.quantity > 1) {
                cartItem.quantity--;
            } else {
                if (this.getters['getCartWithoutOrderbumps'].length > 1) {
                    cartStorage.splice(cartIndex, 1);
                }
            }

            // Atribui uma nova referência ao objeto para o Vue detectar a mudança
            state.cart = [...cartStorage];

            if (process.client) {
                localStorage.setItem('cart', JSON.stringify(cartStorage));
            }

            // Calcular o total do carrinho
            const totalValue = cartStorage.reduce((total, item) => total + ((item.price / 100) * item.quantity), 0);
                       
            // Verifica regras de cupom baseadas na quantidade
            const totalQuantity = cartStorage.reduce((total, item) => total + item.quantity, 0);
            const minItemsInCart = this.getters['getCoupon'].min_items_in_cart;
            const minValueInCart = this.getters['getCoupon'].min_value_in_cart;

            if (totalQuantity < minItemsInCart) {
                state.coupon = '';
                localStorage.removeItem('coupon');
            }

            if (totalValue < minValueInCart) {
                state.coupon = '';
                localStorage.removeItem('coupon');
            }

            const coupons = this.getters['getAutomaticCoupons'];

            if (coupons.length > 0) {
                const cartTotalValue = cartStorage.reduce((total, item) => total + ((item.price / 100) * item.quantity), 0);
                const cartTotalQuantity = cartStorage.reduce((total, item) => total + (item.quantity), 0);
                let coupon_applyed = coupons.find(coupon => coupon.min_items_in_cart <= cartTotalQuantity && coupon.min_value_in_cart < cartTotalValue && coupon.discount_formatted < cartTotalValue);

                if (coupon_applyed) {
                    coupon_applyed = JSON.parse(JSON.stringify(coupon_applyed));
                    this.commit('setCoupon', coupon_applyed);
                }
            }
        }
    },
    updateCustomOptionQuantity(state, payload) {
        let cartStorage = JSON.parse(localStorage.getItem('cart')) || [];

        if (!cartStorage || !Array.isArray(cartStorage)) {
            cartStorage = [];
        }

        const cartIndex = cartStorage.findIndex(item => item.cartvar === payload.item.cartvar);
        if (cartIndex !== -1) {
            const cartItem = cartStorage[cartIndex];

            if (payload.operation === 'plus') {
                cartItem.custom_options[payload.optionIndex].quantity++;
            } else if (payload.operation === 'less' && cartItem.custom_options[payload.optionIndex].quantity > 1) {
                cartItem.custom_options[payload.optionIndex].quantity--;
            } else {
                cartItem.custom_options.splice(payload.optionIndex, 1);
            }

            state.cart = cartStorage;
            if (process.client) {
                localStorage.setItem('cart', JSON.stringify(cartStorage));
            }

            this.commit('updateQuantity', { item: cartItem, operation: payload.operation });

        }
    },
    removeCartItem(state, payload) {
        console.log(payload)
        let cart = state.cart
        cart = cart.filter((item) => item.cartvar !== payload.cartvar)
        state.cart = cart

        if (process.client) {
            localStorage.setItem('cart', JSON.stringify(cart))
        }
    },
    removeCoupon(state) {
        state.coupon = ''
        localStorage.removeItem('coupon')
    },
    setOrderBumps(state, payload) {
        state['orderbumps'] = payload
    },
    setFirstStepValid(state, payload) {
        state['formState']['firstStepValid'] = payload
    },
    setPaymentMethodSelected(state, payload) {
        if (payload) {
            let gateway_default = state.gateways.find(
                (u) => u.payment_method === 'all'
            )

            state.gateway = gateway_default

            state.gateways.forEach((v, k) => {
                if (v.payment_method === 'creditcard' && payload === 1) {
                    state.gateway = v
                }

                if (v.payment_method === 'billet' && payload === 2) {
                    state.gateway = v
                }

                if (v.payment_method === 'pix' && payload === 3) {
                    state.gateway = v
                }

                state['paymentMethodSelected'] = payload
            })
        }
    },
    setPaymentMethods(state, payload) {
        if (payload) {
            state['payment_methods'] = payload
        }
    },
    setPaymentMethodPreSelected(state, payload) {
        state['payment_method_pre_selected'] = payload
    },
    setEventsState(state, payload) {
        payload['InitiateCheckout']
            ? (state['eventsFire']['InitiateCheckout'] =
                payload['InitiateCheckout'])
            : undefined
        payload['Lead']
            ? (state['eventsFire']['Lead'] = payload['Lead'])
            : undefined
        payload['AddPaymentInfo']
            ? (state['eventsFire']['AddPaymentInfo'] =
                payload['AddPaymentInfo'])
            : undefined
        payload['Purchase']
            ? (state['eventsFire']['Purchase'] = payload['Purchase'])
            : undefined
    },
    setPixels(state, payload) {
        state['pixels'] = payload
    },
    setTracking(state, payload) {
        state['tracking'] = payload
    },
    setBonus(state, payload) {
        if (payload) {
            state['bonus'] = payload
        }
    },
    setCustomer(state, payload) {
        if (typeof payload['cpf'] !== 'undefined') {
            payload['document'] = payload['cpf']
        }

        if (payload.email) {
            payload['email'] = payload.email
                .normalize('NFD')
                .replace(/\p{Mn}/gu, '')
                .toLocaleLowerCase()
        }

        state['customer'] = JSON.parse(JSON.stringify(payload))
        if (payload) {
            localStorage.setItem('customer', JSON.stringify(payload))
        }
    },
    setPaymentData(state, payload) {
        state['paymentData'] = JSON.parse(JSON.stringify(payload))
    },
    setInstallments(state, payload) {
        state['setup']['installments'] = parseInt(payload)
    },
    setTransactionData(state, payload) {
        state['transactionData'] = payload
    },
    setDatalayerModel(state, payload) {
        state['datalayerModel'] = payload
    },
    setMercadoPagoInstallments(state, payload) {
        state.mercadopagoInstallments = payload
    },
    setAppMaxInstallments(state, payload) {
        state.appMaxInstallments = payload
    },
    setCompanyName(state, payload) {
        state.company_name = payload
    },
    setCompanyDomain(state, payload) {
        state.company_domain = payload
    },
    setKlaviyoKey(state, payload) {
        state.klaviyoKey = payload
    },
    setDeviceId(state, payload) {
        state.device_id = payload
    },
    clearShipping(state) {
        state.shipping = {};
    },
}

export const actions = {
    setCustomer({ commit }, payload) {
        let dataLead = payload
        if (process.client) {
            if (localStorage.getItem('customer')) {
                commit(
                    'setCustomer',
                    JSON.parse(localStorage.getItem('customer'))
                )
                dataLead = JSON.parse(localStorage.getItem('customer'))
            } else {
                commit('setCustomer', JSON.parse(JSON.stringify(payload)))
            }
        } else {
            commit('setCustomer', JSON.parse(JSON.stringify(payload)))
        }
        return dataLead
    },
    setCartItem({ commit }, payload) {
        let dataCart = payload
        if (process.client) {
            if (localStorage.getItem('cart')) {
                commit('setCartItem', JSON.parse(localStorage.getItem('cart')))
                dataCart = JSON.parse(localStorage.getItem('cart'))
            } else {
                commit('setCartItem', JSON.parse(JSON.stringify(payload)))
            }
        } else {
            commit('setCartItem', JSON.parse(JSON.stringify(payload)))
        }
        return dataCart
    },
    pushErros({ commit }, payload) {
        fetch(`https://api.unicopag.com.br/api/api/notifications/errors`, {
            method: 'POST',
            mode: 'cors',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                title: payload.title,
                message: payload.message,
                sound: payload.sound ?? 'pushover',
            }),
        })
    },
    callEventTracker({ commit }, payload) {
        setTimeout(() => {
            try {
                if (this.state.tracker_init === true) {
                    callTrackEvent(payload.event, payload.extra_params, this.state.company_domain)
                }
            } catch (error) {
                console.error(error)
            }
        }, 1000)
    },
}
